import { fromJS } from "immutable";

import ubuntuCharWidthMap from "../utils/ubuntuCharWidthMap";
import Dimensions from "./styles/dimensions";

const TRUE_AVERAGE_CHAR_PIXEL_WIDTH = 7.3796;
const CHAR_PIXEL_MULTIPLIER = 1.05; //1;
export const AVERAGE_CHAR_PIXEL_WIDTH = TRUE_AVERAGE_CHAR_PIXEL_WIDTH * CHAR_PIXEL_MULTIPLIER;
// export const AVERAGE_CHAR_PIXEL_HEIGHT = 17;
export const LINE_HEIGHT_RATIO = 1.3;
export const SPACE_CHAR_PIXEL_WIDTH = 5;

export const TEXT_TITLE_PADDING = 0; //4;

const baseFontSize = Dimensions.BASE_FONT_SIZE;

export const defaultCharacterWidthMap = fromJS(ubuntuCharWidthMap).map(values =>
  Number(values.get(baseFontSize.toString()).toFixed(2))
);
